/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import styled from "styled-components";
import { Text, theme } from "@nordcloud/gnui";
import {
  NewUnallocatedResourcesConfig,
  SchedulerConfig,
  ServiceNowConfig,
  EmailConfig,
  SlackConfig,
  ScanConfig,
  SavingsSuggestionsConfig,
  KPIConfig,
  CostsConfig,
  BudgetsConfig,
  AnomalyCostsConfig,
} from "../../constants";
import { DraggableComponent } from "./DraggableComponent";

const Config = [
  {
    title: "Trigger",
    components: [ScanConfig, SchedulerConfig],
  },
  {
    title: "Select Data",
    components: [
      BudgetsConfig,
      CostsConfig,
      KPIConfig,
      NewUnallocatedResourcesConfig,
      SavingsSuggestionsConfig,
      AnomalyCostsConfig,
    ],
  },
  {
    title: "Send Data",
    components: [EmailConfig, ServiceNowConfig, SlackConfig],
  },
];

export function FlowComponents() {
  return (
    <Container>
      <Text weight="bold">Components</Text>
      {Config.map(({ title, components }) => (
        <ComponentContainer key={title}>
          <Text m="0">{title}</Text>
          {components.map((component) => {
            return (
              <DraggableComponent
                key={component.type}
                componentConfig={component}
              />
            );
          })}
        </ComponentContainer>
      ))}
    </Container>
  );
}

const Container = styled.div`
  min-width: 20rem;
  margin-right: ${theme.spacing.spacing04};
`;

const ComponentContainer = styled.div`
  margin-top: ${theme.spacing.spacing04};
`;
